export default __webpack_public_path__ + "static/media/highlight.516b76ab.jpg";